import { useEffect } from 'react'

export function useWorkspaceDocumentTitle(roomName: string | undefined, roomId: string | undefined) {
    useEffect(() => {
        document.title = roomName
            ? `${roomName} - FlashRoom`
            : 'FlashRoom';
    }, [roomName, roomId]);
}
